
import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import StrengthsSection from './components/StrengthsSection';
import ServicesSection from './components/ServicesSection';
import ComparisonSection from './components/ComparisonSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import ProcessSection from './components/ProcessSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const HomePage = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  useEffect(() => {
    const handleOpenForm = () => {
      setIsFormOpen(true);
    };

    window.addEventListener('openContactForm', handleOpenForm);

    return () => {
      window.removeEventListener('openContactForm', handleOpenForm);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header onContactClick={() => setIsFormOpen(true)} />
      <HeroSection onConsultClick={() => setIsFormOpen(true)} />
      <FeaturesSection />
      <StrengthsSection />
      <ComparisonSection />
      <CaseStudiesSection />
      <ProcessSection />
      <ServicesSection onConsultClick={() => setIsFormOpen(true)} />
      <FAQSection />
      <Footer isFormOpen={isFormOpen} setIsFormOpen={setIsFormOpen} />
    </div>
  );
};

export default HomePage;
